/**
 * PrivacySLPrivacyPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait PrivacySLPrivacyPage
 */

import { usePrivacySLPrivacyPageLogic } from '@/hooks/traits/usePrivacySLPrivacyPageLogic';
import type { PrivacySLPrivacyPageConfig } from '@/hooks/traits/usePrivacySLPrivacyPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { PrivacySLPrivacyView as PrivacySLPrivacyViewEntity } from '@app/shared';
import { PrivacySLPrivacyFooterView } from '@/components/traits/PrivacySLPrivacyFooterView';
import { PrivacySLPrivacyHeaderView } from '@/components/traits/PrivacySLPrivacyHeaderView';
import { PrivacySLPrivacyTextView } from '@/components/traits/PrivacySLPrivacyTextView';
import { Box } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface PrivacySLPrivacyPageViewProps {
  config?: Partial<PrivacySLPrivacyPageConfig>;
}

export function PrivacySLPrivacyPageView({ config: propsConfig }: PrivacySLPrivacyPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = usePrivacySLPrivacyPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['PrivacySLPrivacyView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="PrivacySL" trait="PrivacySLPrivacyPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="PrivacySLPrivacyPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><PrivacySLPrivacyHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box className="py-16 md:py-24" bg="transparent" fullWidth={true}><PrivacySLPrivacyTextView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Box><PrivacySLPrivacyFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default PrivacySLPrivacyPageView;
